import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { FiltersMenuStyle } from "app/components/React/FiltersBar/FiltersMenu";

export const StyledPageHeader = styled.div<{ topOffset: number }>`
    ${FiltersMenuStyle} {
        top: ${({ topOffset }) => topOffset || 0}px;
        right: 0;
        display: flex;
        border-left: 1px solid ${colorsPalettes.carbon[50]};
        height: 60px;
        width: 60px;
        align-items: center;
        justify-content: center;
    }

    .Sidebar-container.animation-overlay.animation-right {
        top: ${({ topOffset }) => (topOffset ? topOffset + 60 : 60)}px;
    }
`;
